import { Link } from "react-router";
import Button from "../../components/Button";
import Header from "../../components/Header";
import { motion } from "motion/react";
import Logo from "../../components/Logo";

export default function Home() {
  return (
    <>
      <div
        className="p-4 h-screen flex flex-col bg-background"
        data-testid="home-page"
      >
        <div className="flex justify-between items-center">
          <Header />
        </div>
        <div className="flex-grow flex items-center">
          <div
            className="flex flex-col items-center justify-center max-w-2xl text-center mx-auto"
            style={{
              marginTop: "-200px",
            }}
          >
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="flex flex-col items-center justify-center"
            >
              <Logo className="text-6xl" />
              <div className="font-medium text-secondary mt-4">
                La plateforme qui connecte artistes et professionnels en un seul
                espace. Échangez, collaborez, créez.
              </div>
            </motion.div>
            <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
              <Link to="/signup">
                <Button variant="primary" className="mt-8 h-12 px-8">
                  Commencer
                </Button>
              </Link>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
}
